import { styled, u, keyframes } from '../../../../shared/theming-sc'
import { keyframesFadeIn } from '../../../../shared/utilities/styleUtils'

const DateRangeLabel = styled.div`
  width: 100%;
  font-size: 15px;
  line-height: 1.6;
  color: ${u.getColor('greyDark')};
  margin-bottom: ${u.getSpacing('tiny')}px;
`

const DateRangeDescription = styled.div`
  width: 100%;
  font-size: 13px;
  line-height: 1.54;
  color: ${u.getColor('greyDark')};
  margin-bottom: ${u.getSpacing('tiny')}px;
`

const DateRangeWrapper = styled.div`
  width: 100%;
  position: relative;
`

const DateRangeOuter = styled.div`
  width: 100%;
  height: 60px;
  margin-top: ${p => (p.hideMarginTop ? 0 : u.getSpacing('small'))}px;
  position: relative;
  box-sizing: border-box;
  min-width: 280px;

  svg {
    position: absolute;
    right: ${u.getSpacing('small')}px;
    top: ${u.getSpacing('small')}px;
  }

  input {
    box-sizing: border-box;
    height: 60px;
    width: 100%;
    border-radius: 5px;
    background-color: white;
    border: solid 1px ${p => (p.errorState ? u.getColor('complementary2') : u.getColor('greyMuted'))};
    color: ${p => (p.errorState ? u.getColor('complementary2') : u.getColor('greyDark'))};
    padding: ${u.getSpacing('small')}px ${u.getSpacing('large')}px ${u.getSpacing('small')}px ${u.getSpacing('small')}px;
    font-size: ${u.getFontSize('md')};
    box-shadow: ${props => (props.active ? '5px 5px 4px 0 rgba(0, 0, 0, 0.2)' : '1px 1px 1px 0 rgba(0, 0, 0, 0.0)')};
    transition: box-shadow 0.175s ease-out;
  }

  input:focus {
    border: solid 1px ${u.getColor('greyDark')};
    outline: none;
  }

  input[type=text]::-ms-clear {
    display: none;
    width : 0;
    height: 0;
  }

  input[type=text]::-ms-reveal {
    display: none;
    width : 0;
    height: 0;
  }
`

const keyframesCalendarIn = keyframes`
  from{
    transform: scale(0.95,0.95);
  }
  to{
    transform: scale(1,1);
  }
`
const DateRangeCalendar = styled.div`
  position: absolute;
  width: 100%;
  max-width: 320px;
  min-width: 280px;
  padding: 0 10px 10px;
  display: block;
  z-index: 100000;
  overflow: hidden;
  border-radius: 5px !important;
  border: 1px solid #ddd;
  background: white;
  top: ${props => (props.fromDateClicked ? (props.label ? (props.optionalDescription ? '114px' : '89px') : '60px') : (props.label ? (props.optionalDescription ? '194px' : '169px') : '140px'))};
  box-shadow: ${props => (props.active ? '5px 5px 4px 0 rgba(0, 0, 0, 0.2)' : '')};
  margin: ${u.getSpacing('smaller')}px 0;
  animation: ${keyframesFadeIn} 0.075s ease-out, ${keyframesCalendarIn} 0.5s cubic-bezier(0.15,0.995,0,1);
  
  p {
    margin: 0 0 10px 0;
    padding: 0 10px;
    box-sizing: border-box;

    &.error {
      color: red;
      text-transform: none;
      letter-spacing: 1px;
    }
  }

  .Calendar {
    margin: 0 0px;
    width: 100%;
    box-shadow: none;

    thead{
      display: table;
    }

    tbody{
      display: table;
    }

    tr {
      &.month-header {
        th {

          &.previous {
            width: 22px;
            height: 46px;
            padding: 10px 0 13px 0 !important;
            position: relative;
            display: inline-block;

            button {
              color: transparent;
              border: none;
              width: 22px;
              outline: none;
              padding: 0 0 0 0 ;

              line-height: 1.5;
              vertical-align: middle;
              background: transparent url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' height='20' width='20' viewBox='0 0 20 20'%3E%3Cpath d='M8.212 5l.306.293-4.661 4.471H17v.47H3.856l4.662 4.473-.306.293L3 10z' fill='none' stroke='%234D4D4D'/%3E%3C/svg%3E") no-repeat 50% 50%;
            }
          }

          &[colspan="5"] {
            width: 125px;
            text-align: center;
            padding: 10px 0 13px 0 !important;
          }

          &.next {
            width:22px;
            height:46px;
            position: relative;
            display: inline-block;
            padding: 10px 0 13px 0 !important;

            button {
              color: transparent;
              border: none;
              width: 22px;
              outline: none;
              padding: 0 0 0 0;

              line-height: 1.5;
              vertical-align: middle;
              background: transparent url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' height='20' width='20' viewBox='0 0 20 20'%3E%3Cpath d='M11.788 5l-.306.293 4.661 4.471H3v.47h13.144l-4.662 4.473.306.293L17 10z' fill='none' stroke='%234D4D4D'/%3E%3C/svg%3E") no-repeat 50% 50%;
              &:disabled {
                background: transparent url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' height='20' width='20' viewBox='0 0 20 20'%3E%3Cpath d='M11.788 5l-.306.293 4.661 4.471H3v.47h13.144l-4.662 4.473.306.293L17 10z' fill='none' stroke='%23DDDDDD'/%3E%3C/svg%3E") no-repeat 50% 50%;
              }
            }
          }
        }
      }
    }

    td, th {
      padding: 0 !important;
      width: 43px;
      text-align: center !important;
    }

    td {
      border-top: none;

      button {
        font-family: ${u.getFontFamily('knowledge', 'regular')};
        border: none;
        font-size: 13px;
        background-color: transparent;
        padding: 0 !important;
        width: 100%;
        border-radius: 4px;
        color: ${u.getColor('greyDark')};
        &:disabled {
          color: ${u.getColor('greyMuted')};
        }
      }

      &.selected {
        button {
          color: white;
          background: ${u.getColor('primary')};
          font-weight: 500;
          margin: 0 5px;
          max-width: 33px;
        }
      }

      &.today {
        button:not(.from):not(.to) {
          border: 1px solid ${u.getColor('greyMuted')};
          color: ${u.getColor('greyDarker')};
          background: white;
          font-weight: 400;
          margin: 0 5px;
          max-width: 33px;
        }
      }

      & .from {
        background: ${u.getColor('greyMuted')};
        color: ${u.getColor('greyDark')};
        font-weight: 500;
        margin: 0 5px;
        max-width: 33px;
      }

      &.other-month {
        button {
          color: ${u.getColor('greyMuted')} !important;
          background: white !important;
        }

        &.today {
          button {
            border: 1px solid ${u.getColor('greyMuted')};
            color: ${u.getColor('greyMuted')} !important;
            background: white !important;
            margin: 0 5px;
            max-width: 33px;
          }
        }
      }
    }
  }
`

const TodayLink = styled.button`
  position: absolute;
  top: 10px;
  right: 12px;
  padding-right: 0;
  border-width: 0;
  text-decoration: underline;
  font-weight: 600;
  background-color: white;
`

const ErrorDivWrapper = styled.div`
  width: 100%;
  position: relative;
  font-family: ${u.getFontFamily('knowledge', 'regular')};
  font-size: ${u.getFontSize('md')};
  color: ${u.getColor('complementary2')};
  margin-top: ${u.getSpacing('smaller')}px;
`

export {
  DateRangeWrapper,
  DateRangeOuter,
  DateRangeCalendar,
  TodayLink,
  DateRangeLabel,
  DateRangeDescription,
  ErrorDivWrapper
}
